import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import SimplePrimaryBackground from "components/testimonials/SimplePrimaryBackground";
import TwoColWithTwoFeaturesAndButtons from "components/features/TwoColWithTwoFeaturesAndButtons";

export default () => {
  return (
    <AnimationRevealPage>
      <Hero />
      <FeatureStats />

      <TwoColWithTwoFeaturesAndButtons />

      <SimplePrimaryBackground />
      <Footer />
    </AnimationRevealPage>
  );
};
